import { useContext, useMemo } from "react";
import { ProjectContext } from "context/ProjectProvider";
import { isProjectInIntegrationMode } from "utils/utils";
import { useGetProjectINTGState } from "hooks/submittal";

const useSubmittalIntegration = () => {
  const {
    projectDetails,
    projectIntegrationConfig,
    isProcoreProject,
    gqlClientForProject
  } = useContext(ProjectContext);

  const isIntegrationMode = isProjectInIntegrationMode(
    projectDetails ? projectDetails.mode : 0
  );

  const { isIntegrationConfigured } = useGetProjectINTGState({
    client: gqlClientForProject,
    skip: !isIntegrationMode
  });

  const currentSourceType = useMemo(() => {
    if (!projectIntegrationConfig?.length) return "";

    return projectIntegrationConfig[0]?.integration?.system;
  }, [projectIntegrationConfig]);

  return {
    isIntegrationMode,
    projectIntegrationConfig,
    isIntegrationConfigured,
    isProcoreProject,
    currentSourceType
  };
};

export default useSubmittalIntegration;
